import { requester } from '@space-shell/config/request'

import { MembershipEndpoints } from './constants'
import type { Membership } from './types'

/**
 * @deprecated Use useHotRequest instead
 */
class MembershipService {
  static getInfo = async (slug: string) => {
    const response = await requester.get<Membership>(MembershipEndpoints.info(slug))

    return response.data
  }
}

export default MembershipService
